export default __webpack_public_path__ + "media/zurb/img/legacy/reel/instructions-2-1349d6b826f7d4838091d3e98bcffe08.png";